/* ALL SHIPMENTS */
export const GET_ALL_SHIPMENTS = "GET_ALL_SHIPMENTS"
export const GET_ALL_SHIPMENTS_SUCCESS = "GET_ALL_SHIPMENTS_SUCCESS"
export const GET_ALL_SHIPMENTS_FAIL = "GET_ALL_SHIPMENTS_FAIL"

/* ADD NEW SHIPMENT */
export const ADD_SHIPMENT = "ADD_SHIPMENT"
export const ADD_SHIPMENT_SUCCESS = "ADD_SHIPMENT_SUCCESS"
export const ADD_SHIPMENT_FAIL = "ADD_SHIPMENT_FAIL"